var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUiFaqs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2a4 4 0 100 8 4 4 0 000-8zM1 6a5 5 0 1110 0A5 5 0 011 6zm4.713-1.97a1.49 1.49 0 01.972.134h.002A1.501 1.501 0 016.002 7a.5.5 0 01-.004-1 .502.502 0 00.23-.946.49.49 0 00-.596.12.5.5 0 11-.764-.647 1.49 1.49 0 01.845-.498zM6 7.5a.5.5 0 01.5.5v.005a.5.5 0 01-1 0V8a.5.5 0 01.5-.5z",
    fill: "#000"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-ui--faqs-bb67d25fe16d2babc9fcc9998b90f093.svg";
export { SvgIconUiFaqs as Component };